import { Component, OnInit,Output,Input,ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css']
})
export class BreadcrumbComponent implements OnInit {
  @Input() Breadcrumblist:any;
  @Input() ReorderTopic?:string='';
  @Input() Breadcrumb?:string='';
  @Input() File_Name?:string='';
  @Input() File_Name1?:string='';
  @Input() Breadcrumb1?:string='';
  
  // valid:string='new';
  
  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit() {
 
  }
  ngAfterContentChecked(): void {

    this.cdr.detectChanges();
  }

 
  
}
